<div class="add-payment">
  <div class="ui-g-12 p-zero dialog-header">
    <!--Finalized header info  -->
    <ng-container *ngIf="isRevenueRecognitionSettleEnabled && isFinalizedSectionVisible; else paymentHeader">
      <div class="rev-code-title text-truncate">
        <span class="light-color-title"> RO# {{ payment?.estimate?.code }}</span> - {{ payment?.estimate?.title ||
        defaultTitle }}
      </div>
      <div class="rev-customer-info">
        <div class="rev-customer-email-phone">
          {{ displayNameEmail(payment?.customer?.displayName, payment?.customer?.email) }}
          <span *ngIf="payment?.customer?.phone"> - ({{ payment?.customer?.phone | mask : '(000) 000-0000' }})</span>
        </div>
      </div>
    </ng-container>

    <ng-template #paymentHeader>
      <div class="ml-0 send-dialog-heading">
        {{ paymentId ? 'Edit Payment' : 'Add Payment' }}
      </div>
    </ng-template>
    <i class="fal fa-times fa-sm dialog-close" (click)="closePaymentModal({})"></i>
  </div>

  <div
    [ngClass]="isRevenueRecognitionSettleEnabled && isFinalizedSectionVisible ? 'dialog-body-revenue-recognition' : 'dialog-body'">
    <div style="height: 100%" class="ui-g">
      <div class="ui-g-12 p-zero"
        [ngClass]="isRevenueRecognitionSettleEnabled && isFinalizedSectionVisible ? '' : 'h-100'">
        <!-- Start Left panel -->
        <div class="p-zero left-box"
          [ngClass]="isRevenueRecognitionSettleEnabled && isFinalizedSectionVisible ? 'ui-g-8 pb-0 pr-0' : 'h-100 ui-g-8'">
          <div class="payment-modal-alignment-space">
            <!-- Modal inner scroll -->
            <div
              [ngClass]="isRevenueRecognitionSettleEnabled && isFinalizedSectionVisible ? 'modal-inner-scroll-wrapper' : ''">

              <!-- Start Order Section -->
              <div *ngIf="!isRevenueRecognitionSettleEnabled || !isFinalizedSectionVisible" class="ui-g-12 p-0 mb-10px">
                <div class="no-estimate customer" *ngIf="isNewPayment && isOrderEditable">
                  <label class="font-12 font-600 mb-4px">Order*</label>
                  <app-auto-complete id="payment-search" listId="payment-search-list" placeholder="Search order"
                    inactiveItemsKey="isArchived" field="title" theme="border" scrollHeight="192px"
                    inactiveItemsKey="isActive" [suggestions]="estimateSearchResults" [selectInactiveItems]="false"
                    [closeOnSelection]="true" [hasEditableField]="false" [autoFocus]="isOrderEditable"
                    [value]="payment?.estimate?.title" [isLoading]="isSearching" [selectInactiveItems]="false"
                    (appSelect)="onEstimateSearchSelect($event)" (appClickOutside)="showSelected('order')"
                    (appClear)="clearSearchResult('order')" (appCompletedMethod)="onEstimateSearch($event)">
                    <ng-template let-item appTemplate="item">
                      <div class="ui-g p-0" [ngClass]="{ disabled: !item?.isArchived }">
                        <div class="ui-g-12 p-0 flex-center-center">
                          <div class="ui-g-1 p-0" *ngIf="item?.isActive">
                            <i class="fal fa-file-alt font-16"></i>
                          </div>

                          <div class="ui-g-1 p-0" *ngIf="!item?.isActive">
                            <i class="fal fa-lock font-16"></i>
                          </div>

                          <div class="flex-column ui-g-11 p-0" [ngClass]="{ 'ro-restricted-mode': !item?.isActive }">
                            <div class="flex-between-center width-100p">
                              <span class="font-bold capitalize"> {{ item?.code }} - {{ item?.title || defaultTitle }}
                              </span>

                              <span class="font-bold" *ngIf="item?.workFlowStatus?.name !== 'Invoice'">
                                {{ item?.workFlowStatus?.name || 'No Status' }}
                              </span>

                              <span class="font-bold" *ngIf="item?.workFlowStatus?.name === 'Invoice'">
                                {{ item?.workFlowStatus?.name || 'No Status' }} # {{ item.orderStatus === 'invoice' &&
                                item.invCode ? item.invCode : item.code }}</span>
                            </div>

                            <div class="flex-between-center width-100p">
                              <span class="capitalize">{{ item?.customer?.displayName || noCustomerText }}</span>
                              <span class="">{{ item?.customer?.phone | mask : '(000) 000-0000' }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </app-auto-complete>
                </div>

                <div *ngIf="!isOrderEditable" class="customer"
                  [ngClass]="{ 'not-allowed': !isNewPayment, pointer: isNewPayment }" (click)="toggleEditMode('order')">
                  <label class="font-600 font-12 mb-4px">Order*</label>
                  <div class="input-box" [ngClass]="{ 'ro-restricted-mode': !payment?.estimate?.isActive }">
                    <div class="font-12 title-icon">
                      <div class="icon-wrapper" *ngIf="payment?.estimate?.isActive">
                        <i class="fal fa-file-alt file-icon"></i>
                      </div>
                      <div class="icon-wrapper" *ngIf="!payment?.estimate?.isActive">
                        <i class="fal fa-lock lock-icon"></i>
                      </div>
                      <div class="font-light capitalize font-bold code-title text-truncate">{{ payment?.estimate?.code
                        }} - {{ payment?.estimate?.title || defaultTitle }}</div>
                      <div class="font-light font-capitalize text-right workflow-status">
                        {{ payment?.estimate?.workFlowStatus }}
                      </div>
                    </div>
                    <div class="font-10">
                      <div class="font-light customer-email-phone">
                        {{ displayNameEmail(payment?.customer?.displayName, payment?.customer?.email) }}
                        <span *ngIf="payment?.customer?.phone"> - ({{ payment?.customer?.phone | mask : '(000) 000-0000'
                          }})</span>
                      </div>
                      <div class="font-light"></div>
                    </div>
                  </div>
                </div>

                <div *ngIf="isOrderLocked">
                  <span class="font-12 ro-restricted-error">
                    <i class="fal fa-lock pr-1"></i>
                    <span> This RO is currently being updated by {{ orderRestriction?.employeeFirstName }} {{
                      orderRestriction?.employeeLastName }}, therefore a payment cannot be added. </span>
                  </span>
                </div>

                <div *ngIf="isInvoiceLocked && isInvoiceLockOn">
                  <span class="font-12 ro-restricted-error">
                    <i class="fal fa-lock pr-1"></i>
                    <span> This invoice is locked; please switch RO to Estimate to add payment. </span>
                  </span>
                </div>
              </div>
              <!-- Start Order Section -->

              <!-- Payment Type -->
              <div class="ui-g-12 p-0 mb-10px">
                <div class="ui-g-12 p-zero">
                  <h5 class="rev-heading" *ngIf="isRevenueRecognitionSettleEnabled && isFinalizedSectionVisible">Payment
                  </h5>
                  <p class="font-12 font-600 mb-4px float-left">Payment types*</p>
                </div>

                <div [ngClass]="{ 'payment-not-allowed': isArchived || afterOnlinePayment || afterSwipePayment }"
                  class="ui-g-12 p-zero">
                  <div class="payment-methods mb-2 flex-wrap">
                    <!-- <ng-container *ngIf="payment?.paymentType !== 'thirdParty'; else thirdPartyPaymentTypes"> -->
                    <ng-container *ngFor="let method of paymentTypes; let i = index">
                      <div *ngIf="method?.value === 'thirdParty'"
                        class="flex-center-center thirdy-party-divider-section pl-1 pr-1">
                        <div class="divider-height border"></div>

                      </div>
                      <div id="payment-method-{{ method.label }}" class="payment-method-card text-center pointer"
                        (click)="activateMethodCard(method, 'true')"
                        [pTooltip]="isPaymentTypeActive(method) && !isFetchingCreditMemos && method.tooltip" [ngClass]="{
                            'disabled not-allowed': isPaymentTypeActive(method) || validateChangePaymentData(),
                            'active-card': method.value === activePayment?.value
                          }">
                        <div class="payment-method-inner">
                          <i class="font-24 {{ method.icon }}"></i>
                          <p class="font-12 font-abold mb-0">{{ method.label }}</p>
                        </div>
                      </div>
                    </ng-container>
                    <!-- </ng-container> -->

                    <!-- <ng-template #thirdPartyPaymentTypes>
                      <div id="payment-method-third-party" class="payment-method-card text-center pointer active-card">
                        <div class="payment-method-inner">
                          <i class="font-24 fal fa-store"></i>
                          <p class="font-12 font-abold mb-0">Third party</p>
                        </div>
                      </div>
                    </ng-template> -->
                  </div>
                </div>
              </div>

              <!-- Third party account -->
              <!-- <div class="ui-g-12 p-0 mb-10px" *ngIf="payment?.paymentType === 'thirdParty'">
                <label class="font-12 font-600 mb-4px">Third party account</label>
                <app-input id="payment-third-party-acc" type="text" theme="border" class="font-13"
                  [hasHoverBorderBottom]="false" [disabled]="disabled" [value]="payment?.paymentMethod?.name"
                  [hasHoverEffect]="false">
                </app-input>
              </div> -->

              <!-- ChargeCard -->
              <div
                *ngIf="(activePayment.value === 'card' && featureIsPayRixEnable && isPayrixConnected && !paymentId) || (activePayment.value === 'card' && isGlobalPayConnected && isGlobalPayEnabled)"
                class="ui-g-12 p-0 mb-10px">
                <label class="font-12 font-600 mb-4px">
                  <span>Charge Card*</span>
                </label>
              </div>

              <!-- sub buttons online entry -->
              <div class="ui-g-12 p-0 mb-10px p-zero paymentMethods" *ngIf="
                  (activePayment.value === 'card' && featureIsPayRixEnable) ||
                  (activePayment.value === 'card' && isGlobalPayEnabled)
                " [ngClass]="{ disabled: isArchived || paymentId || validateChangePaymentData() }">
                <div [ngClass]="terminalList.length > 0 ? 'ui-g-4 p-0' : 'ui-g-6 p-0'">
                  <button [disabled]="isCardOnlineDisabled() || validateChangePaymentData()"
                    id="OnlineCardEntryCheckBox" class="btn btn-white btn-border pointer btn-submit mr-1 w-100"
                    style="font-size: 9px" [ngClass]="{ 'payment-active-btn': isPaymentOnline && !isSwipeOnline && payment?.isCardSwipe}"
                    (click)="paymentMethod(true)">
                    Online Card Entry
                  </button>
                </div>
                <div *ngIf="terminalList.length > 0" class="ui-g-4 p-0 pr-1 pl-1">
                  <button id="SwipeCardEntryCheckBox" [disabled]="paymentId || validateChangePaymentData()"
                    class="btn btn-white btn-border pointer btn-submit mr-1 w-100" style="font-size: 9px"
                    [ngClass]="{ 'payment-active-btn': isSwipeOnline && isPaymentOnline }" (click)="swipeCard(true)">
                    Card Swipe
                  </button>
                </div>
                <div [ngClass]="terminalList.length > 0 ? 'ui-g-4 p-0' : 'ui-g-6 p-0'">
                  <button id="ManualCardEntryCheckBox" [disabled]="validateChangePaymentData()"
                    class="btn btn-white btn-border pointer btn-submit mr-1 w-100" style="font-size: 9px"
                    [ngClass]="{ 'payment-active-btn': !isPaymentOnline || !payment?.isCardSwipe}" (click)="paymentMethod(false)">
                    Manual Payment
                  </button>
                </div>
              </div>
              <!-- buttons end -->
              <!-- charge card end -->

              <!-- Check No -->
              <div class="ui-g-12 p-0 mb-10px" *ngIf="activePayment.value === 'cheque'">
                <label class="font-12 font-600 mb-4px">{{ dataService.checkTxt }} number*</label>
                <app-input id="payment-cheque-no" type="text" theme="border" mask="0*" placeholder="0" class="font-13"
                  [hasHoverBorderBottom]="false" [disabled]="disabled" [value]="payment.checkNo"
                  [hasHoverEffect]="false" (appChange)="handleChange($event, 'checkNo')">
                </app-input>
              </div>

              <!--on 3rd party selection -->
              <div class="ui-g-12 p-0 mb-10px"
                *ngIf="isRevenueRecognitionSettleEnabled && ['thirdParty'].includes(activePayment.value)">
                <div class="ui-g-6 p-0 pr-2">
                  <label class="font-12 font-600 mb-4px">Vendor</label>
                  <app-dropdown placeholder="Select" theme="border" position="bottom" field="name" scrollHeight="200px"
                    styleClassSelectedView="payment-method-dropdown" id="payment-third-party-vendor"
                    listId="payment-third-party-vendor-list" [fontSize]="12" [setPositionDynamically]="false"
                    [disabled]="false" [options]="thirdPartyAssociatedVendors" [isDropdownIconVisible]="true"
                    [value]="payment?.thirdPartyVendor" (appSelect)="handleChange($event, 'thirdPartyVendor')">
                  </app-dropdown>
                </div>
                <div class="ui-g-6 p-0">
                  <label class="font-12 font-600 mb-4px">Credit Memo #</label>
                  <app-input id="payment-credit-memo-number" styleClassContainer="min-height-31p" type="text"
                    theme="border" mask="0*" placeholder="" class="font-13" [hasHoverBorderBottom]="false"
                    [disabled]="false" [value]="payment?.creditMemoNumber" [hasHoverEffect]="false"
                    (appChange)="handleChange($event, 'creditMemoNumber')">
                  </app-input>
                </div>
              </div>

              <!-- Amount & Date -->
              <div class="ui-g-12 p-0 mb-10px">
                <div class="ui-g-4 p-0 pr-2">
                  <label class="font-12 font-600 mb-4px">Amount*</label>
                  <app-input id="payment-amount" placeholder="$0.00" theme="border" [fontSize]="13"
                    [selectTextOnFocus]="true" [hasHoverBorderBottom]="false"
                    [allowDecimal]="focus?.collectedAmount ? true : false" [autoFocus]="focus.collectedAmount"
                    [disabled]="isArchived || afterOnlinePayment || afterSwipePayment || activePayment?.value === 'creditPayment'
                     || validateChangePaymentData()" [hasHoverEffect]="false"
                    [value]="focus.collectedAmount ? payment.collectedAmount : (payment.collectedAmount | currency : usd)"
                    (appChange)="handleChange($event, 'collectedAmount')" (appFocus)="handleFocus()"
                    (appBlur)="validation()">
                  </app-input>

                  <label id="payment-validation-amount" class="error-label" *ngIf="validate.amount">
                    {{ validate.amount }}
                  </label>
                  <label id="payment-validation-range" class="error-label" *ngIf="validate.range">
                    {{ validate.range }}
                  </label>
                </div>

                <div class="ui-g-4 p-0 pr-2">
                  <label class="font-12 font-600 mb-4px">Date</label>
                  <div>
                    <div
                      [ngClass]="{ 'disabled-with-default': isArchived || afterOnlinePayment || afterSwipePayment || (!changePaymentData && isPaymentDataPrivilgesEnabled) }"
                      class="calendar-input flex-between-center payment-date pointer">
                      <p-calendar id="payment-date" placeholder="Date" styleClass="payment-pointer" dateFormat="M d, yy"
                        appendTo="body" [(ngModel)]="payment.paymentDate" [readonlyInput]="true"
                        [minDate]="payment?.estimate?.createdAt" [maxDate]="maxDateRange"
                        [disabled]="isArchived || afterOnlinePayment || afterSwipePayment || (!changePaymentData && isPaymentDataPrivilgesEnabled)"
                        (onSelect)="onDateTimeChange($event)" #paymentDateTimeEl></p-calendar>
                      <i class="fal fa-calendar-alt pr-2"
                        [ngClass]="{ 'd-none': isArchived || afterOnlinePayment || afterSwipePayment }"
                        (click)="(isPaymentDataPrivilgesEnabled && changePaymentData &&
                    paymentDateTimeEl.showOverlay()) || (!isPaymentDataPrivilgesEnabled && paymentDateTimeEl.showOverlay())"></i>
                    </div>
                  </div>
                </div>

                <div class="ui-g-4 p-0">
                  <label class="font-12 font-600 mb-4px">Time*</label>
                  <div [ngClass]="{ 'disabled-with-default': isArchived || afterOnlinePayment || afterSwipePayment }">
                    <kendo-timepicker [(value)]="paymentTime" popupClass="testing"
                      [disabled]="isArchived || afterOnlinePayment || afterSwipePayment || (!changePaymentData && isPaymentDataPrivilgesEnabled)"
                      [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }">
                    </kendo-timepicker>
                  </div>
                </div>
              </div>

              <!-- Change calculator -->
              <app-calculate-change *ngIf="isCalculateChangeEnabled && activePayment.value === 'cash'"
                [data]="payment"></app-calculate-change>
              <!-- Change calculator -->

              <!-- Payment method -->
              <div *ngIf="activePayment?.value && activePayment?.value !== 'creditPayment'" class="payment-completed">
                <div class="ui-g-12 p-0 mb-10px">
                  <div *ngIf="!isPaymentOnline || afterSwipePayment || afterOnlinePayment"
                    [ngClass]="isPaymentOnline ? 'ui-g-6 pr-0' : 'ui-g-12 p-0'">
                    <label class="font-12 font-600 mb-4px">
                      <span>Payment method*</span>
                    </label>

                    <app-dropdown placeholder="Select" theme="border" position="top" field="name" scrollHeight="200px"
                      styleClassSelectedView="payment-method-dropdown" [id]="'payment-selection-' + activePayment.value"
                      [listId]="'payment-selection-' + activePayment.value + '-list'" [fontSize]="12"
                      [setPositionDynamically]="false" [hasError]="validate.paymentMethod"
                      [disabled]="isArchived || afterOnlinePayment || afterSwipePayment || validateChangePaymentData()"
                      [options]="paymentMethods" [isDropdownIconVisible]="true" [value]="selectedPaymentMethod"
                      (appSelect)="onCardTypeSelect($event); validate.paymentMethod = '';">
                    </app-dropdown>
                  </div>
                  <!-- Swipe Terminals-->
                  <div
                    *ngIf="activePayment.value === 'card' && isPaymentOnline && isSwipeOnline && ((featureIsPayRixEnable && isPayrixConnected) || isGlobalPayCardSwipConnected)"
                    [ngClass]="payment?.estimate?.workFlowStatus === 'Invoice' ? 'ui-g-12 p-0' : 'ui-g-6 pr-0'">
                    <label class="font-12 font-600 mb-4px">
                      <span>Select Terminal*</span>
                    </label>

                    <app-dropdown placeholder="Select Terminal" theme="border" position="top" field="name"
                      scrollHeight="200px" styleClassSelectedView="payment-method-dropdown" [fontSize]="12"
                      [setPositionDynamically]="false"
                      [disabled]="isArchived || afterOnlinePayment || afterSwipePayment" [options]="terminalList"
                      [isDropdownIconVisible]="true" [hasCustomItemTemplate]="true" [value]="selectedTerminal"
                      (appSelect)="onTerminalSelect($event)">
                      <ng-template let-item appTemplate="item">
                        <div class="ui-g single-terminal">
                          <div class="ui-g-12 p-0 flex-start-start">
                            <div class="w-100">
                              <p class="font-14 font-secondary-900 font-600 m-0">{{ item?.name }}</p>
                              <i class="font-12" *ngIf="!item.isTransactionPending">Available</i>
                              <i class="font-12" *ngIf="item.isTransactionPending">Unavailable
                                <span class="pl-4">#{{ item?.pendingRo }}</span>
                              </i>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </app-dropdown>
                  </div>
                </div>
                <!-- Credit card no & security code -->
                <div
                  *ngIf="(activePayment.value === 'card' && !isPaymentOnline) || afterOnlinePayment || afterSwipePayment"
                  class="ui-g-12 p-0 mb-10px">
                  <div class="ui-g-6 p-0 pr-2">
                    <label class="font-12 font-600 mb-4px">Last 4 digits*</label>
                    <app-input type="text" mask="9999" theme="border" placeholder="" class="font-13"
                      id="payment-card-last-4" [hasHoverBorderBottom]="false"
                      [disabled]="disabled || afterOnlinePayment || afterSwipePayment" [hasHoverEffect]="false"
                      (appChange)="handleChange($event, 'card4Digits')" [value]="payment.card4Digits">
                    </app-input>
                  </div>
                  <div class="ui-g-6 p-0">
                    <label class="font-12 font-600 mb-4px">Confirmation no.*</label>
                    <app-input id="payment-card-conf-no" type="text" theme="border" placeholder="" mask="0*"
                      [patterns]="confirmCardPattern" class="font-13" [hasHoverBorderBottom]="false"
                      [disabled]="disabled || afterOnlinePayment" [hasHoverEffect]="false"
                      (appChange)="handleChange($event, 'cardConfNo')" [value]="payment.cardConfNo">
                    </app-input>
                  </div>
                </div>
              </div>

              <!-- PayOnline -->

              <!-- featurefeatureIsPayRixEnableEnable -->
              <div [hidden]="afterOnlinePayment || paymentId"
                *ngIf="activePayment.value === 'card' && isPaymentOnline && !isSwipeOnline"
                class="ui-g-12 p-zero mb-10px">
                <label class="font-12 font-600 mb-4px">Pay online</label>
                <div class="form-group font-14 mb-20 notes">
                  <button [disabled]="!payment?.collectedAmount || validate.amount" id="OnlineCardEntryButton"
                    (click)="openScreen()" class="btn btn-primary pointer btn-submit mr-1 w-100">
                    Pay Online - Card Entry
                    <i *ngIf="opening" class="fal fa-spinner rotate"></i>
                  </button>
                </div>
              </div>
              <!-- featurefeatureIsPayRixEnableEnable -->

              <div [hidden]="afterOnlinePayment || paymentId"
                *ngIf="activePayment.value === 'card' && isPaymentOnline && isSwipeOnline && ((featureIsPayRixEnable && isPayrixConnected) || isGlobalPayCardSwipConnected)"
                class="ui-g-12 p-zero mb-8px">
                <label class="font-12 font-600 mb-4px">Pay online</label>
                <div class="form-group font-14 mb-20 notes">
                  <button [disabled]="(!payment?.collectedAmount && selectedTerminal) || validate.amount"
                    id="SwipeCardEntryButton" (click)="openCardSwipe()" class="btn btn-submit mr-1 w-100"
                    [ngClass]="[payment?.collectedAmount && selectedTerminal ? 'btn-primary pointer' : 'btn-white']">
                    Pay Online - Card Swipe
                    <i *ngIf="opening" class="fal fa-spinner rotate"></i>
                  </button>
                </div>
              </div>
              <!-- Payonline end -->

              <ng-container *ngIf="isFinalizedSectionVisible && activePayment?.value === 'creditPayment'">
                <div class="ui-g-12 p-0 mb-10px">
                  <label class="font-14 font-bold mb-4px font-gray-35">Available credits</label>
                  <table class="applied-ro">
                    <tr>
                      <th class="title">Memo #</th>
                      <th class="amount">Initial credit</th>
                      <th class="amount">Remaining</th>
                      <th class="apply-now">Apply now</th>
                    </tr>

                    <tr *ngFor="let credits of availableCredits; let i = index">
                      <td class="title">{{ credits?.code }}</td>
                      <td class="amount">{{ credits?.amount }}</td>
                      <td class="amount">{{ credits?.remainingAmount }}</td>
                      <td class="apply-now">
                        <app-input id="apply-credit-amount" placeholder="$0.00" theme="border" [fontSize]="12"
                          validationId="error-first-name" [errorMessage]="" [isInvalid]="credits?.error"
                          value="{{ credits?.focus ? credits?.appliedAmount : (credits?.appliedAmount | currency : usd) }}"
                          [selectTextOnFocus]="true" [hasHoverBorderBottom]="false" [hasHoverEffect]="false"
                          styleClass="" [allowDecimal]="credits?.focus" [autoFocus]="credits?.focus" maxlength="7"
                          (appChange)="handleCreditChange($event, i)" (appFocus)="credits['focus'] = true"
                          (appBlur)="credits['focus'] = false">
                        </app-input>
                      </td>
                    </tr>
                  </table>

                  <div [hidden]="!remainingBalanceValidation" class="error-label mt-2">
                    <i class="fal fa-info-circle text-dark"></i>
                    Credit amount must be less than the remaining balance
                  </div>
                </div>
              </ng-container>

              <!-- Notes -->
              <div *ngIf="showNotes" class="ui-g-12 p-zero mb-10px">
                <label class="font-12 font-600 mb-4px">Notes</label>
                <div class="form-group custom-text-area font-14 mb-2 notes">
                  <textarea id="payment-notes" name="notes" [disabled]="isArchived" placeholder="Notes" rows="4"
                    (ngModelChange)="onChangenNote($event)" [(ngModel)]="payment.notes"></textarea>
                </div>
              </div>

              <!-- Checkbox section -->
              <div class="ui-g-12 p-zero" *ngIf="isRevenueRecognitionSettleEnabled && isFinalizedSectionVisible">
                <div class="flex-between-end flex-row">
                  <div class="flex-column">
                    <div class="mark-paid p-zero">
                      <app-checkbox [inputId]="'cb-mark-order-paid'" [disabled]="isArchived || isNotVehicleInfo"
                        label="Mark order as paid" tooltipStyleClass="paid-disabled"
                        [isChecked]="!isNotVehicleInfo ? payment.isPaidFull : false" tooltipPosition="top"
                        *ngIf="isNotVehicleInfo; else isInvoiceType"
                        pTooltip="Please add any missing authorization or VIN/Mileage information to update"
                        (appChange)="handleIsPaidChange($event)">
                      </app-checkbox>
                      <ng-template #isInvoiceType>
                        <app-checkbox [inputId]="'cb-mark-order-paid'" [disabled]="isArchived"
                          label="Mark order as paid" [isChecked]="payment.isPaidFull"
                          (appChange)="handleIsPaidChange($event)">
                        </app-checkbox>
                      </ng-template>
                    </div>

                    <div class="mark-workflo-status p-zero">
                      <app-checkbox [inputId]="'cb-payment-workflow-paid'" label="Update workflow status to “Paid”"
                        [isChecked]="payment.workFlowPaid" [disabled]="isArchived"
                        (appChange)="handleworkFlowPaidChange($event)">
                      </app-checkbox>
                    </div>
                  </div>
                  <!-- (payment?.isPaidFull && payment?.estimate?.isFinalized)? 'Cannot apply payment - RO is finalized & already paid.':
                  !activePayment?.value? 'Select a payment type to apply payment': ''  -->
                  <button id="payment-btn-save" class="btn btn-primary btn-submit"
                    [pTooltip]="!payment?.estimate?.unpaid || !unPaid ? 'Cannot apply payment - no remaining balance' :!activePayment?.value? 'Select a payment type to apply payment': !payment?.collectedAmount ? 'Amount must be greater than zero.' : ''"
                    [disabled]="  (activePayment.value === 'card' && !isPaymentOnline && isSwipeOnline  
                    ? !payment.card4Digits || !payment.cardConfNo : false) || remainingBalanceValidation ||
                    isFetchingCreditMemos ||
                      !payment.estimate?.unpaid ||
                      (payment.estimate?.unpaid < 0 && isFinalizedAsThirdParty) ||
                      !unPaid ||
                      !activePayment?.value ||
                      (isInvoiceLocked && isInvoiceLockOn) ||
                      isProcessing ||
                      isArchived ||
                      !payment?.collectedAmount ||
                      ((isOrderLocked) && isLockOrderEnabled) ||
                      (activePayment.value === 'card' &&
                        isPaymentOnline &&
                        featureIsPayRixEnable &&
                        (isSwipeOnline || isPaymentOnline) &&
                        isPayrixConnected &&
                        !afterOnlinePayment &&
                        !afterSwipePayment &&
                        !paymentId) ||
                      (activePayment.value === 'card' && isPaymentOnline && isGlobalPayConnected && !afterOnlinePayment && !afterSwipePayment && !paymentId)
                    " (click)="onSubmit(true)">
                    <span [ngClass]="{ 'pr-2': isProcessing }">
                      {{ activePayment?.value === 'creditPayment' ? 'Apply credit' : 'Apply payment' }}
                    </span>
                    <!-- <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i> -->
                  </button>
                </div>
              </div>
              <!-- Finalized footer + checkbox seciton -->
              <div class="ui-g-12 p-zero mb-10px footer-extention"
                *ngIf="isRevenueRecognitionSettleEnabled && isFinalizedSectionVisible">
                <!-- Finalization types -->
                <div class="rev-bottom-wrapper">
                  <div class="rev-heading-wrapper">
                    <h5>Finalization</h5>
                    <p>Finalize types*</p>
                  </div>

                  <div class="finalize-option-wrapper">
                    <app-invoice-settlement [paid]="payment?.estimate?.paid" [estimate]="estiamteToChargeAccount"
                      [isChargeAccountEnabled]="isChargeAccountEnabled"
                      [hasUserPermissionToFinlize]="hasUserPermissionToFinlize" [customerId]="customerId"
                      [orderId]="payment?.estimate?.estimateId" [isProcessing]="isProcessing || isFetchingEstPayment"
                      (setLoadingState)="isProcessing = $event" [selectedPaymentMethod]="activePayment"
                      [payment]="payment" (closeDialog)="closePaymentModal({ isSuccess: false }, false)"
                      (refetchOrder)="setEstimateDetails({ _id: payment?.estimate?.estimateId})"
                      (setFinalizationState)="setFinalizationState($event)"
                      (openReviewDialog)="openReviewDialog($event)"
                      (openMarkRoThirdPartyDialog)="openMarkRoThirdPartyDialog($event)"
                      (onClickSettlementOption)="handleSettlementOption($event)"
                      (resetPaymentMethods)="resetPaymentMethods()"></app-invoice-settlement>
                  </div>
                </div>
              </div>

            </div>


          </div>
        </div>

        <!-- Start Right Panel -->
        <ng-container *ngIf="isFinalizedSectionVisible; else oldPaymentSummary">
          <div class="p-zero right-box"
            [ngClass]="isRevenueRecognitionSettleEnabled && isFinalizedSectionVisible ? 'ui-g-4 rev-summary' : 'ui-g-4'">
            <div class="payment-modal-alignment-space">
              <div class="ui-g-12 p-0 mb-2 border-bottom">
                <h5 class="rev-summary-heading">Summary</h5>
                <div class="label-row">
                  <div class="label-heading font-600">Total order value</div>

                  <div class="label-value font-700">
                    {{ payment.estimate.total | currency : usd }}
                  </div>
                </div>

                <!-- All payment history -->
                <div class="label-row pl-2" *ngFor="let payment of paymentHistory; let i = index">
                  <div class="left-heading label-heading text-truncate" *ngIf="!payment?.isCreditPayment">
                    <span class="" tooltipPosition="left"
                      tooltipStyleClass="ticket-tooltip modifier payment-hostory-size finalized completed"
                      [escape]="false" [pTooltip]="payment.tooltip">
                      <ng-container
                        *ngIf="['cheque', 'thirdParty'].includes(payment?.paymentType); else otherPaymentTypes">
                        {{ payment?.paymentType === 'cheque' ? dataService.checkTxt : payment?.thirdPartyName }}
                      </ng-container>
                      <ng-template #otherPaymentTypes>
                        <span [hidden]="['card', 'writeOff'].includes(payment?.paymentType)" class="text-capitalize">
                          {{ payment?.paymentType }}
                        </span>
                        <span *ngIf="payment?.paymentType === 'card'">
                          <span *ngIf="payment?.isOnline">Card (Online)</span>
                          <span *ngIf="!payment?.isCardSwipe">
                            {{ payment?.isCardSwipe ? 'Card (Swipe)' + payment?.cardType : payment?.isOnline ? '' :
                            'Card (Manual)' }}
                          </span>
                          <span *ngIf="payment?.card4Digits">*{{ payment?.card4Digits || '' }}</span>
                        </span>
                      </ng-template>
                    </span>
                  </div>

                  <div class="left-heading label-heading" *ngIf="payment?.isCreditPayment">
                    <span class="" tooltipPosition="left"
                      tooltipStyleClass="ticket-tooltip modifier payment-hostory-size completed" [escape]="false"
                      [pTooltip]="payment.tooltip">
                      {{ payment?.creditMethodType }}
                    </span>
                  </div>
                  <div class="right-heading label-value">
                    <span class="font-gray-light">
                      {{ payment?.amount | currency : usd }}
                    </span>
                  </div>

                  <!-- Refund section -->
                  <div class="refund-section-wrapper" tooltipPosition="left"
                    tooltipStyleClass="ticket-tooltip modifier payment-hostory-size completed" [escape]="false"
                    [pTooltip]="refund.tooltip" *ngFor="let refund of payment.refunds">
                    <div class="left-heading label-heading">
                      <span class="">
                        {{ refund?.isVoidPayment ? 'Void' : 'Refunded' }}
                      </span>
                    </div>

                    <div class="right-heading label-value">
                      <span class="">
                        {{ refund?.amount | currency : usd }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="label-row" [ngClass]="{'border-bottom-lightest mb-2': writeOffPaymentHistory?.length}">
                  <div class="label-heading font-600">Paid to date</div>

                  <div class="label-value font-700">
                    {{ payment.estimate?.paid || 0 | currency : usd }}
                  </div>
                </div>

                <!-- write off history -->
                <div class="label-row pl-2" *ngFor="let payment of writeOffPaymentHistory; let i = index">
                  <div class="left-heading label-heading text-truncate" *ngIf="!payment?.isCreditPayment">
                    <span class="" tooltipPosition="left"
                      tooltipStyleClass="ticket-tooltip modifier payment-hostory-size finalized completed"
                      [escape]="false" [pTooltip]="payment.tooltip">
                      <span class="text-capitalize">
                        {{ payment?.writeOffName }}
                      </span>
                    </span>
                  </div>

                  <div class="right-heading label-value">
                    <span class="font-gray-light">
                      {{ payment?.amount | currency : usd }}
                    </span>
                  </div>

                  <!-- Refund section -->
                  <div class="refund-section-wrapper" tooltipPosition="left"
                    tooltipStyleClass="ticket-tooltip modifier payment-hostory-size completed" [escape]="false"
                    [pTooltip]="refund.tooltip" *ngFor="let refund of payment.refunds">
                    <div class="left-heading label-heading">
                      <span class="">
                        {{ refund?.isVoidPayment ? 'Void' : 'Refunded' }}
                      </span>
                    </div>

                    <div class="right-heading label-value">
                      <span class="">
                        {{ refund?.amount | currency : usd }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="label-row" *ngIf="writeOffPayment > 0">
                  <div class="label-heading font-600">Write-off</div>

                  <div class="label-value font-700">
                    {{ writeOffPayment || 0 | currency : usd }}
                  </div>
                </div>

                <div class="label-row" *ngIf="isFinalizedAsThirdParty && overAgePayment > 0">
                  <div class="label-heading font-600">Excess Commission</div>

                  <div class="label-value-overage font-700">
                    {{ overAgePayment || 0 | currency : usd }}
                  </div>
                </div>
              </div>

              <div class="ui-g-12 p-0 mb-2">
                <div class="label-row">
                  <div class="label-heading font-600">
                    {{ payment?.estimate?.finalizeType === 'accountsReceivable' ? 'AR balance' : 'Remaining balance' }}
                  </div>

                  <ng-container *ngIf="isFinalizedAsThirdParty">

                    <div class="label-value font-600 zero-balance">
                      {{((overAgePayment + payment.estimate?.unpaid) - writeOffPayment) || 0 | currency : usd }}
                    </div>

                    <!-- <div class="label-value font-600" [ngClass]="{ 'zero-balance': remainingBalance === 0 }" *ngIf="this.activePayment?.value === 'writeOff'">
                      {{ (payment.estimate?.unpaid - writeOffPayment) || 0 | currency : usd }}
                    </div> -->
                  </ng-container>

                  <div class="label-value font-600" [ngClass]="{ 'zero-balance': remainingBalance === 0 }"
                    *ngIf="!isFinalizedAsThirdParty">
                    {{ (payment.estimate?.unpaid - writeOffPayment) || 0 | currency : usd }}
                  </div>


                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-template #oldPaymentSummary>
          <div class="p-zero right-box"
            [ngClass]="isRevenueRecognitionSettleEnabled && isFinalizedSectionVisible ? 'ui-g-4 rev-summary' : 'ui-g-4'">
            <div class="payment-modal-alignment-space">
              <div class="ui-g-12 p-0 mb-2 border-bottom">
                <div class="label-row mb-1 border-bottom pt-0">
                  <div class="label-heading">Total order value</div>

                  <div class="label-value">
                    {{ payment.estimate.total | currency : usd }}
                  </div>
                </div>

                <div class="label-row mb-1 mt-2">
                  <div class="label-heading">Paid to date</div>

                  <div class="label-value">
                    {{ payment.estimate.paid || 0 | currency : usd }}
                  </div>
                </div>

                <div class="label-row mb-1 mt-2" *ngIf="payment.refunds && payment.refunds.length > 0">
                  <div class="label-heading">Refund</div>

                  <div class="label-value">
                    {{ payment.refundToDate || 0 | currency : usd }}
                  </div>
                </div>

                <div class="label-row mb-2">
                  <div class="label-heading">Payment amount</div>

                  <div class="label-value payment-amount" *ngIf="collectedAmount !== 0">
                    {{ focus.collectedAmount ? payment.collectedAmount : (payment.collectedAmount || 0 | currency : usd)
                    }}
                  </div>

                  <div class="label-value payment-amount" *ngIf="collectedAmount === 0">
                    {{ collectedAmount || 0 | currency : usd }}
                  </div>
                </div>
              </div>

              <div class="ui-g-12 p-0 mb-2">
                <div class="label-row">
                  <div class="label-heading">Remaining balance</div>

                  <div class="label-value font-700" [ngClass]="{ 'zero-balance': remainingBalance === 0 }">
                    {{ remainingBalance || 0 | currency : usd }}
                  </div>
                </div>
              </div>

              <!-- Refund only panel-->
              <div *ngIf="payment.refunds && payment.refunds.length > 0">
                <!--  Payment History -->
                <div class="ui-g-12 p-0 border-bottom payment-history">
                  <div class="label-row mb-1">
                    <label class="label-heading font-13 font-600">Payment details</label>
                  </div>
                </div>

                <div class="ui-g-12 p-0 mb-2">
                  <div class="label-row">
                    <div class="label-heading">Gross payment</div>

                    <div class="label-value">
                      {{ focus.collectedAmount ? payment.collectedAmount : (payment.collectedAmount | currency : usd) }}
                    </div>
                  </div>
                </div>

                <div class="ui-g-12 p-0 mb-2">
                  <div class="label-row">
                    <div class="label-heading">Refund to date</div>

                    <div class="label-value">
                      {{ payment.refundToDate || 0 | currency : usd }}
                    </div>
                  </div>
                </div>

                <div class="ui-g-12 p-0 mb-2">
                  <div class="label-row">
                    <div class="label-heading">Post refund amount</div>

                    <div class="label-value">
                      {{ payment.collectedAmount - payment.refundToDate || 0 | currency : usd }}
                    </div>
                  </div>
                </div>
              </div>

              <!--  Payment History -->
              <div class="ui-g-12 p-0 mt-40 border-bottom payment-history" *ngIf="paymentHistory.length > 0">
                <div class="label-row mb-1">
                  <label class="label-heading font-13 font-600">Payment history</label>
                </div>
              </div>

              <div *ngIf="paymentHistory.length > 0">
                <div class="ui-g-12 p-0 mt-1 payment-history" *ngFor="let pHistory of paymentHistory">
                  <div class="history-row font-11" tooltipPosition="left"
                    tooltipStyleClass="ticket-tooltip modifier payment-hostory-size completed" [escape]="false"
                    [pTooltip]="pHistory.tooltip">
                    <span class="history-heading">
                      {{ pHistory.createdAt | date : 'MMM d, yyyy h:mm a' }}
                    </span>
                    <span class="history-value float-right"> ${{ pHistory?.amount | currency : usd }} </span>
                  </div>

                  <div class="history-payment-type">
                    <span class="history-heading">
                      <span *ngIf="pHistory.paymentType === 'cash'"> Cash </span>

                      <span *ngIf="pHistory.paymentType === 'cheque'"> {{ dataService.checkTxt }} {{ pHistory.checkNo }}
                      </span>

                      <span *ngIf="pHistory.paymentType === 'card' && (pHistory.isOnline || pHistory.isCardSwipe)">
                        {{ pHistory?.isOnline ? 'Card ' + pHistory?.cardType : pHistory?.isCardSwipe ? 'Card ' +
                        pHistory?.cardType : 'Card (Manual)' }}
                      </span>

                      <span [hidden]="pHistory.isOnline || pHistory.isCardSwipe"
                        *ngIf="pHistory.paymentType === 'card'"> Card {{ pHistory.cardType }} *{{ pHistory.card4Digits
                        }} </span>

                      <span *ngIf="pHistory.paymentType === 'Refund'"> {{ pHistory?.title }} </span>

                      <span *ngIf="pHistory.paymentType === 'creditPayment'">
                        {{ pHistory.creditMethodType }}
                      </span>
                      <span *ngIf="pHistory?.madeBy">- {{ pHistory?.madeBy }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <!-- End Right Panel -->
      </div>
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer" *ngIf="!(isRevenueRecognitionSettleEnabled && isFinalizedSectionVisible)">
    <div class="ui-g-6 ui-lg-8 p-0">
      <div class="ui-g-12 p-zero">
        <div class="ui-g-12 ui-lg-4 mark-paid p-zero">
          <app-checkbox [inputId]="'cb-mark-order-paid'" [disabled]="isArchived || isNotVehicleInfo"
            label="Mark order as paid" tooltipStyleClass="paid-disabled"
            [isChecked]="!isNotVehicleInfo ? payment.isPaidFull : false" tooltipPosition="top"
            *ngIf="isNotVehicleInfo; else isInvoiceType"
            pTooltip="Please add any missing authorization or VIN/Mileage information to update"
            (appChange)="handleIsPaidChange($event)">
          </app-checkbox>
          <ng-template #isInvoiceType>
            <app-checkbox [inputId]="'cb-mark-order-paid'" [disabled]="isArchived" label="Mark order as paid"
              [isChecked]="payment.isPaidFull" (appChange)="handleIsPaidChange($event)"> </app-checkbox>
          </ng-template>
        </div>

        <div class="ui-g-12 ui-lg-6 mark-workflo-status p-zero">
          <app-checkbox [inputId]="'cb-payment-workflow-paid'" label="Update workflow status to “Paid”"
            [isChecked]="payment.workFlowPaid" [disabled]="isArchived" (appChange)="handleworkFlowPaidChange($event)">
          </app-checkbox>
        </div>
      </div>
    </div>

    <div class=" ui-g-6 ui-lg-4 p-0 ui-g-4 p-zero text-right payment-add-footer">
      <button id="payment-btn-cancel" class="btn btn-white btn-border pointer btn-submit mr-1"
        (click)="closePaymentModal($event)">Cancel</button>
      <button id="payment-btn-save" class="btn btn-primary btn-submit" [disabled]="
      isFetchingCreditMemos ||
          !activePayment?.value ||
          (isInvoiceLocked && isInvoiceLockOn) ||
          isProcessing ||
          isArchived ||
          ((isOrderLocked || !payment?.estimate?.isActive) && isLockOrderEnabled) ||
          (activePayment.value === 'card' &&
            isPaymentOnline &&
            featureIsPayRixEnable &&
            (isSwipeOnline || isPaymentOnline) &&
            isPayrixConnected &&
            !afterOnlinePayment &&
            !afterSwipePayment &&
            !paymentId) ||
          (activePayment.value === 'card' && isPaymentOnline && isGlobalPayConnected && !afterOnlinePayment && !afterSwipePayment && !paymentId)
        " (click)="onSubmit(true)">
        <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
        <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
      </button>
    </div>
  </div>
</div>
